import { type StoryblokMultilink } from './storyblok'

export const getStoryblokHrefLink = (
  link?: StoryblokMultilink,
): string | undefined => {
  if (!link) {
    return ''
  }

  if (link.linktype === 'story') {
    return `/${link.cached_url}`
  }
  if (link.linktype === 'url') {
    return link.cached_url
  }

  return ''
}
